// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__2MZkk","socialLinks":"footer_socialLinks__sdW3q","copyright":"footer_copyright__JAoGW","credits":"footer_credits__bRpsy"};